const PM_globals = {};
PM_globals.install = function (Vue, options) {

    //Vue.prototype.$patient = window.store.state.activePatient;

    Vue.mixin({
        data: function(){
            return({
                isActiveComponent: false,
                themeUrl: window.themeUrl,
            });
        },
        computed: {
            Helper: function() { return window.Helper; },
            globals: function() { return window.globals; },
        },
        created: function() {
            this.isActiveComponent = true;
        },
        activated: function() {
            this.isActiveComponent = true;
        },
        deactivated: function() {
            this.isActiveComponent = false;
        },
        methods: {
            $tErr: function(str) {
                try {
                    str = str.toLowerCase().replaceAll(' ', '_');
                    return this.$t('error.' + str);
                } catch(error) {
                    captureException(error);
                    return str;
                }
            }
        }
    });
};

export default PM_globals;
